module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/crocodile-star1.0a789355.png";